const displayableMimes = [
  /application\/pdf/,
  /application\/vnd\.openxmlformats-officedocument\.wordprocessingml\.document/,
  /application\/vnd\.ms-word\.document\.macroEnabled\.12/,
  /application\/vnd\.openxmlformats-officedocument\.spreadsheetml\.sheet/,
  /application\/vnd\.ms-excel\.sheet\.macroEnabled\.12/,
  /application\/vnd\.openxmlformats-officedocument\.presentationml\.presentation/,
  /application\/vnd\.ms-powerpoint\.presentation\.macroEnabled\.12/,
  /application\/vnd\.openxmlformats-officedocument\.presentationml\.slideshow/,
  /application\/vnd\.ms-powerpoint\.slideshow\.macroEnabled\.12/,
  /application\/msword/,
  /application\/vnd\.ms-word/,
  /application\/msexcel/,
  /application\/x-excel/,
  /application\/x-msexcel/,
  /application\/vnd\.ms-excel/,
  /application\/vnd\.ms-powerpoint/,
  /application\/powerpoint/,
  /application\/x-powerpoint/,
  /text\/.*/,
  /application\/javascript/,
  /application\/x-javascript/,
  /application\/ecmascript/,
  /application\/json/,
  /application\/xml/,
  /application\/x-python-code/,
  /application\/sql/,
  /application\/twb/,
  /video\/ogg/,
  /video\/mp4/,
  /video\/webm/,
  /video\/theora/,
  /audio\/mpeg/,
  /audio\/wav/,
  /audio\/vnd.wave/,
  /audio\/x-wav/,
  /audio\/wave/,
  /audio\/mp4/,
  /audio\/ogg/,
  /audio\/vorbis/,
  /audio\/webm/,
  /audio\/flac/,
  /image\/gif/,
  /image\/jpeg/,
  /image\/png/,
  /image\/svg/,
  /image\/avif/,
  /image\/apng/,
  /image\/bmp/,
  /image\/emf/,
];

const excelMimes = [
  "application/msexcel",
  "application/x-excel",
  "application/x-msexcel",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel.sheet.macroEnabled.12",
];

const wordMimes = [
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-word.document.macroEnabled.12",
  "application/msword",
  "application/vnd.ms-word",
];

const pptMimes = [
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.ms-powerpoint.presentation.macroEnabled.12",
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
  "application/vnd.ms-powerpoint.slideshow.macroEnabled.12",
  "application/vnd.ms-powerpoint",
  "application/powerpoint",
  "application/x-powerpoint",
];

const videoJsMimes = [
  "video/ogg",
  "video/mp4",
  "video/webm",
  "audio/mpeg",
  "audio/wav",
  "audio/mp4",
  "audio/ogg",
  "audio/webm",
  "audio/flac",
];

export default displayableMimes;

export const canDisplay = (mime) => {
  return displayableMimes.some((r) => r.test(mime));
};

export const isVideoJsMime = (mime) => {
  return videoJsMimes.some((m) => m === mime);
};

export const isExcelMime = (mime) => {
  return excelMimes.some((m) => m === mime);
};

export const isWordMime = (mime) => {
  return wordMimes.some((m) => m === mime);
};

export const isPptMime = (mime) => {
  return pptMimes.some((m) => m === mime);
};

export const isOfficeMime = (mime) => {
  return excelMimes
    .concat(wordMimes)
    .concat(pptMimes)
    .some((m) => m === mime);
};

export const normaliseMime = (mime) => {
  if (mime === "application/xml" || mime === "text/xml") {
    return "text/plain";
  } else if (mime === "audio/vorbis") {
    return "audio/ogg";
  } else if (mime === "audio/x-flac") {
    return "audio/flac";
  } else if (
    mime === "audio/wave" ||
    mime === "audio/vnd.wave" ||
    mime === "audio/x-wav"
  ) {
    return "audio/wav";
  } else if (mime === "video/theora") {
    return "video/ogg";
  }
  return mime;
};
